export class Troncal {
    nombre: string;
    host: string;
    rtp: string = '';
    type = 'friend';
    codec?: string | {codec: string}[] = [] ;
    protocolo = '';
    usuario = '';
    password = '';
    dtmf = 'rfc2833';
    callerid = '';
    nat = 'auto_comedia';
    //
    prefijos?: TroncalPrefijo[] = [];
    
    constructor(){}
}

export class TroncalPrefijo {
    troncal: string;
    contexto: string;
    prioridad: number = 9;
    prefijo: string;
    
    constructor(){}
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./common/troncal.ts